// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"167":"1a258343","619":"91dbc596"}[chunkId] || chunkId) + "." + {"167":"23e3ef6ea58af212","619":"194a94376a478f71","715":"9c367fd1db999bfc","751":"008d5bb9cced6b89","816":"af054ae71c4e4dfc","967":"f37f9ee35fee818c"}[chunkId] + ".js";
};